import { DebugToolsHeader } from '@/Components/DebugToolsHeader';
import { router } from '@inertiajs/react';
import { Toaster } from '@ui/sonner';
import { PropsWithChildren } from 'react';

interface GuestLayoutProps extends PropsWithChildren {
    maxW7xl?: boolean;
}

export default function GuestLayout({
    children,
    maxW7xl = true,
}: GuestLayoutProps) {
    return (
        <div className="flex min-h-screen flex-col bg-gradient-to-br from-blue-50 via-white to-purple-50">
            <DebugToolsHeader isSticky={true} />
            <main className="flex flex-1 flex-col">
                <div
                    className={`mx-auto w-full p-6 pb-16 ${maxW7xl ? 'max-w-7xl' : ''}`}
                >
                    {children}
                </div>
                <Toaster position="top-right" />
            </main>
            <Footer />
        </div>
    );
}

function Footer() {
    return (
        <footer className="border-t bg-gray-50 px-4 py-12">
            <div className="mx-auto max-w-7xl">
                <div className="grid grid-cols-1 gap-8 md:grid-cols-4">
                    <div className="md:col-span-2">
                        <div className="mb-4 flex items-center gap-3">
                            <div className="rounded-lg bg-gradient-to-br from-blue-600 to-purple-600 p-2">
                                <svg
                                    className="h-5 w-5 text-white"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth="2"
                                    viewBox="0 0 24 24"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        d="M13 10V3L4 14h7v7l9-11h-7z"
                                    />
                                </svg>
                            </div>
                            <span className="text-lg font-bold">
                                DebugTools.dev
                            </span>
                        </div>
                        <p className="mb-4 max-w-md text-muted-foreground">
                            A comprehensive collection of debugging and
                            development utilities crafted by developers and
                            advanced AI tools working hand-in-hand.
                        </p>
                    </div>
                    <div>
                        <h3 className="mb-4 font-semibold">Tools</h3>
                        <ul className="space-y-2 text-sm text-muted-foreground">
                            <li>
                                <a
                                    onClick={() =>
                                        router.visit(route('endpoints.index'))
                                    }
                                    className="cursor-pointer text-blue-600 hover:underline"
                                >
                                    API Debugger
                                </a>
                            </li>
                            <li>
                                <a
                                    onClick={() =>
                                        router.visit('/certificate-viewer')
                                    }
                                    className="cursor-pointer text-blue-600 hover:underline"
                                >
                                    Certificate Viewer
                                </a>
                            </li>
                            <li>
                                <a
                                    onClick={() =>
                                        router.visit(
                                            route('product-planning.index'),
                                        )
                                    }
                                    className="cursor-pointer text-blue-600 hover:underline"
                                >
                                    Product Planning
                                </a>
                            </li>
                            <li>
                                <a
                                    onClick={() =>
                                        router.visit(route('base64.index'))
                                    }
                                    className="cursor-pointer text-blue-600 hover:underline"
                                >
                                    Base64 Encoder/Decoder
                                </a>
                            </li>
                            <li>
                                <a
                                    onClick={() =>
                                        router.visit(
                                            route(
                                                'sample-data-generator.index',
                                            ),
                                        )
                                    }
                                    className="cursor-pointer text-blue-600 hover:underline"
                                >
                                    Sample Data Generator
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
                <div className="mt-8 flex flex-col items-center justify-between border-t pt-8 text-sm text-muted-foreground md:flex-row">
                    <p>
                        © {new Date().getFullYear()} DebugTools.dev. All rights
                        reserved.
                    </p>
                    <p className="mt-2 md:mt-0">
                        With ❤️ from{' '}
                        <a
                            href="https://sg.linkedin.com/in/derrickleemy"
                            className="font-medium text-blue-600 hover:underline"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Derrick
                        </a>
                    </p>
                </div>
            </div>
        </footer>
    );
}
